import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box } from '@chakra-ui/react';

import { HeroCarousel, CategoryTiles, EditorialBanner, TabbedProducts, VisitStore } from '../components/home/HomeSections';
import useCatalog from '../hooks/useCatalog';
import Reveal from '../components/layout/Reveal';
import { getAllImages, getAllMiniImages } from '../services/ImageServices';
import { HOME_COPY } from '../config/store';

// Home (design-system.md §5.1): hero → category tiles → editorial banner → "new this week" banner
// → tabbed product grid → store block. The About block and footer come from <Footer>.
const Home = () => {

  const navigate = useNavigate();
  const { categories, products, loading } = useCatalog();
  const [heroImages, setHeroImages] = useState([]);
  const [miniImages, setMiniImages] = useState([]);

  useEffect(() => {
    getAllImages().then(r => setHeroImages(r.images || r.allImages || [])).catch(() => { });
    getAllMiniImages().then(r => setMiniImages(r.miniImages || [])).catch(() => { });
  }, []);

  const shop = (state = {}) => navigate('/search', { state });
  const openCategory = (categoryId) => shop(categoryId ? { categoryId } : {});
  const editorialCategory = categories.find(c => c.name.toLowerCase().includes(HOME_COPY.editorial.match));

  return (
    <Box>
      <HeroCarousel images={heroImages} copy={HOME_COPY.hero} onShop={() => shop()} />
      <Reveal><CategoryTiles categories={categories} products={products} openCategory={openCategory} /></Reveal>
      <Reveal><EditorialBanner
        image={miniImages[0]?.url}
        title={HOME_COPY.editorial.title}
        ctas={[{ label: HOME_COPY.editorial.cta, onClick: () => openCategory(editorialCategory?._id) }]}
      /></Reveal>
      <Reveal><EditorialBanner
        image={miniImages[1]?.url}
        title={HOME_COPY.newThisWeek.title}
        ctas={[{ label: 'Shop new in', onClick: () => shop() }, { label: 'Shop all', onClick: () => shop() }]}
      /></Reveal>
      <TabbedProducts categories={categories} products={products} loading={loading} onViewAll={openCategory} />
      <Reveal><VisitStore /></Reveal>
    </Box>
  );
};

export default Home;
